import { render, staticRenderFns } from "./releasePolicyDeclareDetail.vue?vue&type=template&id=556b1ee6&scoped=true&"
import script from "./releasePolicyDeclareDetail.vue?vue&type=script&lang=js&"
export * from "./releasePolicyDeclareDetail.vue?vue&type=script&lang=js&"
import style0 from "./releasePolicyDeclareDetail.vue?vue&type=style&index=0&id=556b1ee6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b1ee6",
  null
  
)

export default component.exports